<template>
    <div class="screen" style="width: 100%; margin: 0; padding: 20px; text-align: left; box-sizing: border-box; height: 100%">
      <side-menu-header :role="store.state.user.role"></side-menu-header>
        <div>
          <div style="margin-top: 50px;">
              <div class="first_name" style="font-size: 33px; font-weight: normal; font-style: normal; color: #0F202F;">{{firstname}} {{surname}}</div>
          </div>
          <div style="top: 22%; color: black; text-align: left; width: 100%; margin-top: 30px;">
              <div class="input__container driver__infos__container">
                  <div class="section__header">Personal Info</div>
                  <div class="filed__container">
                      <div class="input-field-area">
                          <div>First Name</div>
                          <input class="input-filed" type="text" placeholder="eg. Jane" v-model="firstname">
                      </div>
                      <div class="input-field-area">
                          <div>Last Name</div>
                          <input class="input-filed" type="text" placeholder="eg. Doe" v-model="surname">
                      </div>
                      <div class="input-field-area">
                          <div>Email</div>
                          <input class="input-filed" type="text" placeholder="eg. myemail@myemail.com" v-model="email" disabled="disabled">
                      </div>
                      <div class="input-field-area">
                          <div>Phone Number</div>
                          <input class="input-filed" type="text" placeholder="123-456-7890" v-model="telephoneNumber" maxlength="50">
                      </div>
                      <!-- <div class="input-field-area">
                          <div>Password</div>
                          <input class="input-filed" type="password" placeholder="eg. password" v-model="password">
                      </div> -->
                  </div>
              </div>
              <div class="input__container driver__infos__container">
                  <div class="section__header">Vehicle Info</div>
                  <div class="filed__container">
                      <div class="input-field-area">
                          <div>Brand</div>
                          <div>
                              <select class="input-filed" name="car brand" v-model="carBrand" @change="checkCarBrand" @blur="checkCarBrand" style="height: 34px;width: 253px;">
                               <option disabled value="">Please select one</option>
                              <option v-for="car in store.state.schema.car_models" v-bind:key="car.Make">{{car.Make}}</option>
                              </select>
                          </div>
                      </div>
                      <div class="input-field-area">
                          <div>Model</div>
                          <div>
                              <select class="input-filed" name="car models" v-model="carModel" style="height: 34px;width: 253px;">
                               <option disabled value="">Please select one</option>
                              <option v-for="model in carModels" v-bind:key="model">{{model}}</option>
                              </select>
                          </div>
                      </div>
                      <div class="input-field-area">
                          <div>Year</div>
                          <input class="input-filed" type="text" :oninput="carYearRangeValue()" placeholder="eg. 2020" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" v-model="carYear" >
                      </div>
                      <div class="input-field-area">
                          <div>Color</div>
                          <div id="color-pciker">
                            <div class="wrapper-dropdown">
                              <span @click="toggleDropdown" v-html="selector()">
                              </span>
                              <ul class="dropdown" v-if="colorDropdown">
                                <li v-for="color in colors" v-bind:key="color.name" @click="selectedColor(color.RGB, color.name)">
                                  <span :style="{background: color.RGB}"></span>
                                  {{color.name}}
                                </li>
                              </ul>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="input__container driver__hours__container">
                <div class="section__header">Driving Details</div>
                <div class="filed__container">
                  <div class="input-field-area">
                      <div>How many hours do you drive weekly?</div>
                      <input class="input-filed" type="text" placeholder="eg. 80 Hours" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" :oninput="drivingHourRangeValue()" v-model="driverHours">
                  </div>
                  <div class="input-field-area">
                      <div>When do you usually drive?</div>
                      <div class="driver-time-checkbox">
                        <div v-for="(element, item) in store.state.schema.ride_time" v-bind:key="item" class="selective__options">
                          <button class="button-checkbox button-checkbox-text" @click="changeFlagValue(item, 1)" v-bind:class="[timeFlags[item] ? 'button-checkbox-active' : '']">{{element}}</button>
                        </div>
                      </div>
                  </div>
                  <div class="input-field-area">
                      <div>What platform do you drive for?</div>
                      <div class="driver-platoform-checkbox">
                        <div v-for="(element, item) in store.state.schema.transportation_platform" v-bind:key="item" class="selective__options">
                          <button class="button-checkbox button-checkbox-text" @click="changeFlagValue(item, 2)" v-bind:class="[platformFlags[item] ? 'button-checkbox-active' : '']">{{element}}</button>
                        </div>
                      </div>
                  </div>
                  <div class="password-area">
                    <div class="adway_input_filed_headers">Where do you usually drive?</div>
                    <div class="input-field-area" style="margin-top: 10px;">
                      <label class="input-field-area__label">State</label>
                      <select placeholder="State" class="input-filed input-field-area__input" name="us state" v-model="usState"  style="height: 34px;width: 253px;"  @change="checkStateCities" @blur="checkStateCities">
                        <option disabled value="">Please select one</option>
                        <option v-for="us_state in store.state.schema.US" v-bind:key="us_state.state">{{us_state.state}}</option>
                      </select>
                    </div>
                      <div class="input-field-area">
                        <label class="input-field-area__label">City</label>
                        <select placeholder="City" class="input-filed selection__size input-field-area__input" name="state cities" v-model="usCity">
                          <option disabled value="">Please select one</option>
                          <option v-for="city in cities" v-bind:key="city">{{city}}</option>
                        </select>
                      </div>
                      <!-- <input class="input-filed" type="text" placeholder="eg. Prius" v-model="carModel" > -->
                  </div>

                </div>
              </div>
              <div class="input__container driver__documents__container">
                  <div class="section__header header-doc">Documents</div>
                  <div class="filed__container">
                    <div class="input-field-area">
                        <div class="text">Please upload the picture of your driver license (front)</div>
                        <div class="input__section">
                          <div class="input__context">
                            <input class="input-filed" placeholder="eg. image.jpg" type="text" name="driver license" v-model="driverLicenceImage.name" style="width: 100%;">
                            <img v-if="!driverLicenceImage.flag" src="./../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="driverLicence">
                            <img v-if="driverLicenceImage.flag" src="./../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="driverLicence">
                          </div>
                            <!-- <div id="drivingLicence" v-bind:style="[driverLicenceImage.name !== undefined && driverLicenceImage.name.length > 0 ? cssUpload : cssNonUpload]" class="btn-upload-file" v-bind:class="[driverLicenceImage.name !== undefined  && driverLicenceImage.name.length > 0 ? 'sing-up-document-uploaded-file' : 'sing-up-document-cloud']" @click="driverLicence"></div> -->
                            <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="driver-licence" @change="previewDriverLicenceImage">
                        </div>
                    </div>
                    <div class="input-field-area">
                        <div class="text">Please upload the picture of your insurance</div>
                        <div class="input__section">
                          <div class="input__context">
                            <input class="input-filed" placeholder="eg. image.jpg" type="text" name="insurance" v-model="driverInsuranceImage.name">
                            <img v-if="!driverInsuranceImage.flag" src="./../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="insurance">
                            <img v-if="driverInsuranceImage.flag" src="./../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="insurance">
                          </div>
                          <!-- <div id="driverInsurance" v-bind:style="[driverInsuranceImage.name !== undefined && driverInsuranceImage.name.length > 0 ? cssUpload : cssNonUpload]" class="btn-upload-file" v-bind:class="[driverInsuranceImage.name !== undefined  && driverInsuranceImage.name.length > 0 ? 'sing-up-document-uploaded-file' : 'sing-up-document-cloud']" @click="insurance"></div> -->
                          <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="insurance" @change="previewDriverInsuranceImage">
                        </div>
                    </div>
                    <div class="input-field-area">
                        <div class="text">Please upload the picture of your Uber/Lyft rating</div>
                        <div class="input__section">
                          <div class="input__context">
                            <input class="input-filed" placeholder="eg. image.jpg" type="text" name="rating" v-model="driverRating.name">
                            <img v-if="!driverRating.flag" src="./../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="rating">
                            <img v-if="driverRating.flag" src="./../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="rating">
                          </div>
                          <!-- <div id="driverRating" v-bind:style="[driverRating.name !== undefined && driverRating.name.length > 0 ? cssUpload : cssNonUpload]"  class="btn-upload-file sing-up-document-cloud" v-bind:class="[driverRating.name !== undefined  && driverRating.name.length > 0 ? 'sing-up-document-uploaded-file' : 'sing-up-document-cloud']" @click="rating"></div> -->
                          <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="rating" @change="previewDriverRating">
                        </div>
                    </div>
                    <div class="input-field-area">
                        <div class="txt">Please upload the picture of the side of your car</div>
                        <div class="input__section">
                          <div class="input__context">
                            <input class="input-filed" placeholder="eg. image.jpg" type="text" name="side picture" v-model="sideImage.name">
                            <img v-if="!sideImage.flag" src="./../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="sidePicture">
                            <img v-if="sideImage.flag" src="./../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="sidePicture">
                          </div>
                          <!-- <div id="sideImage" v-bind:style="[sideImage.name !== undefined && sideImage.name.length > 0 ? cssUpload : cssNonUpload]" class="btn-upload-file sing-up-document-cloud" v-bind:class="[sideImage.name !== undefined  && sideImage.name.length > 0 ? 'sing-up-document-uploaded-file' : 'sing-up-document-cloud']" @click="sidePicture"></div> -->
                          <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="side-picture" @change="previewSideImage">
                        </div>
                    </div>
                  </div>
              </div>
          </div>

          <div class="driver-account__footer">
            <div class="adway-notification-div" style="text-align: left; float: left; width: 100%; margin-bottom: 15px; margin-top: 15px;">
              <input type="checkbox" name="adway-notification" id="adway-notification" v-model="notificationCB">
              <label  class="adway-label-checkbox" for="adway-notification">I want to receive Adway's campaign notifications</label>
            </div>
            <div style="float: left; width: 100%;">
              <button class="adway-btn-2-class"  @click="submit">
                <clip-loader class="cliploader__white" :loading="activePasswordChange || activeMakeRequest"/>
                <span v-if="!activePasswordChange && !activeMakeRequest" class="btn__text__normal">Edit Account</span>
              </button>
            </div>
          </div>

        </div>
    </div>
</template>

<script>
import SideMenuHeader from './../design/SideMenuHeader.vue'
import HTTPRequest from './../../plugins/utils/HttpRequest.js'
import store from '@store/index.js'
import { mapGetters } from 'vuex'
import toast from '@utils/toast.js'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
export default {
  name: 'DriverAccount',
  components: {
      SideMenuHeader,
      ClipLoader
  },
  data: function () {
    return {
      firstname: '<No name>',
      surname: '<No surname>',
      email: '',
      telephoneNumber: '',
      carModels: [],
      password: '',
      carBrand: '',
      carModel: '',
      carYear: 0,
      selectedColorName: '',
      selectedColorRGB: '',
      selectedState: '',
      selectedCity: '',
      colors: [],
      timeFlags: [],
      platformFlags: [],
      driverHours: '',
      driverLicenceImage: {name: '', flag: false, file: null},
      driverInsuranceImage: {name: '', flag: false, file: null},
      driverRating: {name: '', flag: false, file: null},
      sideImage: {name: '', flag: false, file: null},
      termsAndConditionsCB: false,
      notificationCB: false,
      noClickColorInputField: true,
      cssNonUpload: {
        backgroundImage: `url(${require('./../../assets/nonUploadFile.png')})`
      },
      cssUpload: {
        backgroundImage: `url(${require('./../../assets/okgreen.svg')})`
      },
      store: store,
      colorDropdown: false,
      noClickColorInputField: true,
      flagsIndex: [],
      platformIndex: [],
      currentYear: new Date().getFullYear(),
      activePasswordChange: false,
      activeMakeRequest: false,
      cities: [],
    }
  },
  methods: {
    drivingHourRangeValue () {
      if (this.driverHours > 80) {
        this.driverHours = 80
      }
      if (this.driverHours < 0) {
        this.driverHours = 0
      }
    },
    carYearRangeValue () {
      if (this.carYear > this.currentYear) {
        this.carYear = this.currentYear
      }
    },
    changeStatusColorInputField () {
        this.noClickColorInputField = !this.noClickColorInputField
    },
    checkCarBrand () {
      this.store.state.schema.car_models.forEach(car => {
        if (car.Make === this.carBrand) {
          this.carModels = car.Models
        }
      })
    },
    checkUSStates () {
      this.store.state.schema.us.forEach(us_state => {

          this.usStates.state = us_state.state
          this.usStates.cities = us_state.cities
      })
    },
    driverLicence () {
      document.getElementById('driver-licence').click()
    },
    insurance () {
      document.getElementById('insurance').click()
    },
    rating () {
      document.getElementById('rating').click()
    },
    sidePicture () {
      document.getElementById('side-picture').click()
    },
    previewDriverLicenceImage (event) {
      this.driverLicenceImage.file = event.target.files[0]
      this.driverLicenceImage.name = this.driverLicenceImage.file.name
      this.driverLicenceImage.flag = true
      // var element = document.getElementById('drivingLicence')
      // element.className = 'image-file-uploaded'
    },
    previewDriverInsuranceImage (event) {
      this.driverInsuranceImage.file = event.target.files[0]
      this.driverInsuranceImage.name = this.driverInsuranceImage.file.name
      this.driverInsuranceImage.flag = true
      // var element = document.getElementById('driverInsurance')
      // element.className = 'image-file-uploaded'
    },
    previewDriverRating (event) {
      this.driverRating.file = event.target.files[0]
      this.driverRating.name = this.driverRating.file.name
      this.driverRating.flag = true
      // var element = document.getElementById('driverRating')
      // element.className = 'image-file-uploaded'
    },
    previewSideImage (event) {
      this.sideImage.file = event.target.files[0]
      this.sideImage.name = this.sideImage.file.name
      this.sideImage.flag = true
      // var element = document.getElementById('sideImage')
      // element.className = 'image-file-uploaded'
    },
    setParameters () {
      toast.successMessage('Data initializing')

      this.setCarBrand(this.user.car_make)
      this.firstname = this.user.firstname
      this.surname = this.user.surname
      this.email = this.user.email
      this.telephoneNumber = this.user.phone
      this.flagsIndex = this.user.ride_time === null ? [] : this.user.ride_time
      this.platformIndex = this.user.platforms === null ? [] : this.user.platforms
      this.carBrand = this.user.car_make
      this.carModel = this.user.car_model
      this.carYear = this.user.car_year
      this.selectedColorRGB = this.user.car_color
      this.usCity = this.user.city
      this.usState = this.user.state
      this.colors = this.schema.colors
      this.driverHours = this.user.driving_per_week
      this.notificationCB = this.user.ADWAY_notifications === null || this.user.ADWAY_notifications === '' ? false : this.user.ADWAY_notifications
      this.driverLicenceImage.name = this.user.license_picture ? 'image1' : ''
      this.driverLicenceImage.flag = this.user.license_picture
      this.driverInsuranceImage.name = this.user.insurance_picture ? 'image2' : ''
      this.driverInsuranceImage.flag = this.user.insurance_picture
      this.driverRating.name = this.user.rating_picture ? 'image3' : ''
      this.driverRating.flag = this.user.rating_picture
      this.sideImage.name = this.user.side_picture ? 'image4' : ''
      this.sideImage.flag = this.user.side_picture
      this.setColorName()
      this.setUsState(this.user.state)
    },
    getTimeArray () {
      let array = []
      for (let index = 0 ; index < this.timeFlags.length ; index++){
        if (this.timeFlags[index]){
          array.push(this.schema.ride_time[index])
        }
      }
      return array
    },
    getPlatformArray () {
      let array = []
      for (let index = 0 ; index < this.platformFlags.length ; index++){
        if (this.platformFlags[index]){
          array.push(this.schema.transportation_platform[index])
        }
      }
      return array
    },
    setColorName () {
      this.colors.forEach((color, name) => {
        if (color.RGB === this.selectedColorRGB) {
          this.selectedColorName = color.name
        }
      })
    },
    setUsState (usState) {
        this.store.state.schema.US.forEach(us => {
        if (us.state === this.usState) {
          this.cities = us.cities
        }
      })
    },
    setCarBrand(carMake){
      this.store.state.schema.car_models.forEach(car => {
        if (car.Make === carMake) {
          this.carModels = car.Models
        }
      })
    },
    setFlagsArray () {
      var self = this
      this.schema.ride_time.forEach(element => {
        self.timeFlags.push(false)
      })
      this.schema.transportation_platform.forEach(element => {
        self.platformFlags.push(false)
      })
      this.flagsIndex.forEach(element => {
        self.timeFlags[self.schema.ride_time.indexOf(element)] = true
      })
      this.platformIndex.forEach(element => {
        self.platformFlags[self.schema.transportation_platform.indexOf(element)] = true
      })
    },
    changeFlagValue (index, array) {
      if (array === 1) {
        this.timeFlags.splice(index, 1, !this.timeFlags[index])
      } else if (array === 2) {
        this.platformFlags.splice(index, 1, !this.platformFlags[index])
      }
    },
    selector () {
      if (!this.selectedColorName) {
        return 'Color'
      } else {
        return `<span style="background: ${this.selectedColorRGB}"></span> ${this.selectedColorName}`
      }
    },
    selectedColor (colorRGB, colorName) {
      this.selectedColorRGB = colorRGB
      this.selectedColorName = colorName
      this.toggleDropdown()
    },
    checkStateCities () {
      this.store.state.schema.US.forEach(us => {
        if (us.state === this.usState) {
          this.cities = us.cities
        }
      })   },
    toggleDropdown () {
      this.colorDropdown = !this.colorDropdown
    },
    submit () {
      this.activeMakeRequest = true
      // if (this.password.length > 0) {
      //   this.activePasswordChange = true
      //   this.changePassword()
      // } else {

      // }
      this.makeRequest();
    },
    makeRequest () {
      var body = {
        API_KEY: this.store.getters.keys.api_key,
        code: this.token.token,
        user: this.user.user,
        data: {
          firstname: this.firstname,
          surname: this.surname,
          phone: this.telephoneNumber,
          car_make: this.carBrand,
          car_model: this.carModel,
          car_year: parseInt(this.carYear),
          car_color: this.selectedColorRGB,
          driving_per_week: this.driverHours,
          lat: 0.0,
          lon: 0.0,
          ride_time: this.getTimeArray(),
          platforms: this.getPlatformArray(),
          ADWAY_notifications: this.notificationCB ? 1 : 0,
          state: this.usState,
          city: this.usCity,
        }
      }
      var formData = new FormData()
      formData.append('json', JSON.stringify(body))
      formData.append('driver_license_picture', this.driverLicenceImage.file)
      formData.append('insurance_picture', this.driverInsuranceImage.file)
      formData.append('rating_picture', this.driverRating.file)
      formData.append('side_picture', this.sideImage.file)
      this.request('/set/profile', 'POST', formData).then((response) => {
        if (response.code === 0) {
          toast.successMessage('User profile updated')
          this.getProfile()
        } else {
          toast.errorMessage(response.message)
          this.activeMakeRequest = false
          if (response.code === 112) {
            this.checkTokenConditions(this.makeRequest)
          }
        }
      }).catch((error) => {
        toast.errorMessage(error)
      })
    },
    stateDifference () {

    },
    changePassword () {
      var url = '/user/password/change'
      var body = {
        data: {
          secret: this.password
        }
      }

      this.request(url, 'POST', body).then((response) => {
        if (response.code === 0) {
          toast.successMessage('Password is reset')
          this.reLogin()
        } else {
          if (response.code === 112) {
            this.checkTokenConditions(this.changePassword)
          }
          toast.errorMessage(response.message)
          this.activePasswordChange = false
        }
      }).catch((error) => {
        toast.errorMessage(error)
      })
    },
    checkTokenConditions (callback) {
      try{
        var expiresDate = new Date(this.token.expires)
      } catch (err) {
        this.$router.push('/login')
      }
      var now = new Date()
      if (expiresDate <= now) {
        this.store.commit('setToken', {})
        this.$router.push('/login')
      } else {
        var body = {
        code: '',
            refresh_token: this.token.refresh_token
        }
        this.request('/refresh/token', 'POST', body).then((response) => {
            if (response.code === 0 ) {
                this.store.commit('setToken', response.data[0])
                this.store.commit('setDriver', response.data[0].driver)
                callback()
            } else if (response.code === 112) {
                this.store.commit('setToken', {})
                this.$router.push('/login')
            }
        }).catch((error) => {
        })
      }
      var token = this.token
      token.redirect = false
      this.store.commit('setToken', token)
    },
    reLogin () {
      var request = new HTTPRequest()
      var url = '/user/login'
      var body = {
        user: this.user.user,
        API_KEY: '',
        data: {
          secret: this.password,
          local_time: this.$moment(new Date()).format(),
        }
      }
      this.password = ''
      request.makeRequest('POST', url, body).then((response) => {
        var parseResponse = JSON.parse(response)
        if (parseResponse.code === 0) {
          toast.successMessage('Password changed')
          this.store.commit('setToken', parseResponse.data[0])
          this.store.commit('setDriver', parseResponse.data[0].driver)
          this.activePasswordChange = false
          this.makeRequest()
        } else {
          toast.errorMessage(parseResponse.message)
          if (parseResponse.code === 112) {
            this.checkTokenConditions(this.reLogin)
          }
        }
      }).catch((error) => {
        toast.errorMessage(error)
      })
    },
    getProfile () {
      this.request('/get/profile', 'POST', {}).then((response) => {
        if (response.code === 0) {
          toast.successMessage('Profile info received')
            console.log( response.data[0])
          this.store.commit('setUser', response.data[0])
        } else {
          toast.errorMessage(response.message)
          if (response.code === 112) {
            this.checkTokenConditions(this.getProfile)
          }
        }
        this.activeMakeRequest = false
      }).catch((error) => {
        toast.errorMessage(error)
        this.$router.push('/login')
      })
    }
  },
  created () {
    this.getProfile()
    this.setParameters()
    this.setFlagsArray()
  },
  computed: {
    ...mapGetters({
        user: 'getUser',
        schema: 'getSchema',
        token: 'getToken'
    })
  },
  watch: {
    schema: function(val) {
      this.checkCarBrand()
    }
  }
}
</script>

<style scoped>
  .input-field-area {
    display: flex;
    flex-direction: column;
  }
  .input-field-area__balel {
    margin-bottom: 4px;
  }
.filed__container{
  padding-top: 20px;
}

.section__header{
  font-size: 20px;
  line-height: 29px;
}

.wrapper-dropdown {
    position: relative;
    width: 237px;
    background: #FFF;
    color: #2e2e2e;
    outline: none;
    cursor: pointer;
    height: 35px;
}

.wrapper-dropdown > span {
	width: 100%;
	display: block;
	border: 1px solid #ababab;
  padding: 6px;
  border-radius: 6px;
}
.wrapper-dropdown > span > span {
  padding: 0 12px;
  margin-right: 5px;
}
.wrapper-dropdown > span:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    right: 16px;
    top: calc(50% + 4px);
    margin-top: -6px;
	  border-width: 6px 6px 0 6px;
    border-style: solid;
	  border-color: #2e2e2e transparent;
}

.wrapper-dropdown .dropdown {
    position: absolute;
	  z-index: 10;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    font-weight: normal;
	  list-style-type: none;
	  padding-left: 0;
	  margin: 0;
	  border: 1px solid #ababab;
	  border-top: 0;
}

.wrapper-dropdown .dropdown li {
    display: block;
    text-decoration: none;
    color: #2e2e2e;
	  padding: 5px;
	  cursor: pointer;
}

.wrapper-dropdown .dropdown li > span {
  padding: 0 12px;
  margin-right: 5px;
}

.wrapper-dropdown .dropdown li:hover {
    background: #eee;
	  cursor: pointer;
}

@media screen and (max-width: 950px) and (min-width:320px) {
       /* div{
         background-color: white;

       } */
       .first_name{
         margin-top: -5%;
       }
       .driver__hours__container{
         margin-top: -18%;
       }

       .driver__infos__container{
          margin-top: -6%;
       }

       .driver__documents__container{
         margin-top: 30%;
       }
        .adway-notification-div{
        text-align: left ;
      }
    }


@media screen and (max-width: 1118px) and (min-width:951px){
      .adway-notification-div{
        text-align: right!important;
        float: right !important;;
      }

      .adway-btn-2-class{
        float:right;
      }

      .driver__infos__container{
          margin-top: -3%;
       }

       .driver__documents__container{
         margin-top: 4%;
       }
}

@media screen and (max-width: 950px) and (min-width:770px){
    .driver__hours__container{
         margin-top: -5%;
       }
}


@media screen and (max-width:600px){
  .adway-btn-2-class{
        width: 100%;
      }
  .input-field-area{
        margin-left: 14%;
  }
  .text{
        width: 75%;
  }
  .input-field-area{
        width:100%;

  }


  .driver__hours__container>.filed__container{
      margin-left: -2%;
      width: 80%;
  }

}

@media screen and (max-width: 450px) and (min-width:310px){

        .screen{
          width: 80%;
        }

        .driver__hours__container{
          margin-top:-33%;
        }
        .driver__infos__container{
          margin-top:-10%;
        }

        .txt{
          width: 70%;
        }
        .driver__documents__container{
            margin-top: 60%;
        }
        .driver__documents__container >.filed__container{
          margin-left: -5%;
        }

       }
</style>
